import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import LoanAgreementNewForm from '../loan-agreement-new-form';

export default function LoanAgreementCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="New Loan Agreement"
        links={[{ name: 'Loans', href: paths.dashboard.loans.root() }, { name: 'New' }]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />

      <LoanAgreementNewForm />
    </Container>
  );
}
